module.exports = __webpack_public_path__ + "img/default-logo.84f34a35.png";